import { Shape } from "./ShapeInterface";
import Konva from "konva";
import { DrawFence } from './DrawFence';

export class FenceCircle implements Shape {

	public sName: string;
	public bSelected: boolean;
	x: number;
	y: number;
	width: number;
	height: number;
	toolTip: any;

	drawShape(start: any, end: any, name: string, point?: any) {
		var width = (start.x > end.x ? start.x - end.x : end.x - start.x);
		var height = (start.y > end.y ? start.y - end.y : end.y - start.y);

		if(start.x > end.x){
			return this.getCircle(end.x + width / 2, end.y + height / 2, Math.sqrt(width * width + height * height) / 2, name, name)
		}else{
			return this.getCircle(start.x + width / 2, start.y + height / 2, Math.sqrt(width * width + height * height) / 2, name, name)
		}
		
	}
	getCircle(x: number, y: number, radius: number, name: string, id: string) {
		DrawFence.FenceCount++;
		return new Konva.Circle({
			x: x,
			y: y,
			radius: radius,
			fill: DrawFence.fillColor,
			draggable: true,
			stroke: '#ffffff',
			strokeWidth: 0,
			name: name,
			id: id + DrawFence.FenceCount
		});
	}
}
